// =======================================
// NomClientPopup.js
// Popup pour demander le nom du client
// =======================================
import React, { useState } from "react";
import "./NomClientPopup.css";

export default function NomClientPopup({ onValidate, onCancel }) {
  const [name, setName] = useState("");

  const validate = () => {
    if (name.trim() === "") return;
    onValidate(name.trim());
  };

  return (
    <div className="popup-overlay">
      <div className="popup-box">
        <h2>Nom du client</h2>

        <input
          type="text"
          placeholder="Ex : Dupont Julien"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="popup-input"
        />

        <div className="popup-buttons">
          <button className="popup-cancel" onClick={onCancel}>
            Annuler
          </button>

          <button className="popup-validate" onClick={validate}>
            Valider
          </button>
        </div>
      </div>
    </div>
  );
}
